import { Pipe, PipeTransform } from '@angular/core';
import { cellRawValue, GridColumn } from '../components/kl-grid/grid.models';

/** Badge color for `col.badge` columns, based on common status-value naming across the app. */
@Pipe({
  name: 'klGridCellSeverity',
  standalone: false,
})
export class KlGridCellSeverityPipe implements PipeTransform {
  transform(row: any, col: GridColumn): 'success' | 'danger' | 'warn' | 'info' | 'secondary' {
    const binding = col.binding;
    const raw = binding ? cellRawValue(row, binding) : undefined;
    const value = String(raw ?? '').toUpperCase();
    if (/SUCCEED|ACCEPT|APPROVED/.test(value)) return 'success';
    if (/FAIL|REJECT|ERROR|CANCEL/.test(value)) return 'danger';
    if (/WAIT|PENDING/.test(value)) return 'warn';
    if (!value) return 'secondary';
    return 'info';
  }
}
